module.exports = __webpack_public_path__ + "h5/img/live-logo.6ef2f493.gif";